require("core-js/modules/es6.object.create");

require("core-js/modules/es6.function.name");

var JsonWebTokenError = require('./JsonWebTokenError');

var NotBeforeError = function NotBeforeError(message, date) {
  JsonWebTokenError.call(this, message);
  this.name = 'NotBeforeError';
  this.date = date;
};

NotBeforeError.prototype = Object.create(JsonWebTokenError.prototype);
NotBeforeError.prototype.constructor = NotBeforeError;
module.exports = NotBeforeError;